<div app-sidenav>
  <app-list-banners class="overflow-y-auto"></app-list-banners>
</div>
